import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { VisuallyHiddenInputStyle } from "./style";
import { VisuallyHiddenInputProps } from "./type";
import { Icon } from "../../Icon";

export const VisuallyHiddenInput: React.FC<VisuallyHiddenInputProps> =
  ({ name, label, type, accept, onChange, error, errorMessage, readOnly }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
      <Box
        component="label"
        htmlFor={ name }
        sx={ {
          ...(readOnly
            ? {}
            : {
              "&:hover": {
                backgroundColor: theme.customColors.backgroundPrimaryCta,
                color: theme.customColors.textPrimaryCta,
                span: {
                  color: theme.customColors.textPrimaryCta
                }
              },
              "&:hover .icon path": {
                fill: theme.customColors.textPrimaryCta
              }
            }),
          span: {
            color: theme.customColors.textPrimary
          },
          alignItems: "center",
          border: `1px solid ${ theme.customColors.border }`,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          paddingLeft: theme.spacing(1.2),
          paddingRight: theme.spacing(0.8),
          minHeight: "56px",
          position: "relative",
          ".icon path": { fill: theme.customColors.textPrimary },
          "&:hover .icon path": { fill: theme.customColors.textPrimaryCta },
          borderRadius: "16px"
        } }
      >
        <Typography variant="body1" component="span">
          { label }
        </Typography>
        <IconButton aria-label={ t("upload_file") } component="span" sx={ { marginLeft: 1 } } disabled={ readOnly }>
          <Icon icon="Icons_upload" size={ 15 } />
        </IconButton>
        <VisuallyHiddenInputStyle
          id={ name }
          type={ type }
          accept={ accept }
          onChange={ onChange }
          disabled={ readOnly }
        />
        { error && (
          <div
            style={ {
              color: theme.customColors.textError,
              left: 0,
              position: "absolute",
              right: "0%",
              top: "100%"
            } }
          >
            { errorMessage }
          </div>
        ) }
      </Box>
    );
  };
